export const DATE_FORMATS = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export const DATE_FORMAT = 'dd.MM.yyyy';
export const DATE_ISO_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'dd.MM.yyyy HH:mm';
export const DATE_TIME_ISO_T_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const DATE_TIME_ISO_FORMAT = 'YYYY-MM-DD HH:mm';

export const TIME_FORMAT = 'HH:mm';

// Time format constants for 12-hour and 24-hour formats
export const MOMENT_TIME_FORMAT_12H = 'hh:mm A';
export const TIME_FORMAT_12H = 'hh:mm a';
export const TIME_FORMAT_24H = 'HH:mm';

// Date-time format constants for 12-hour and 24-hour formats
export const MOMENT_DATE_TIME_FORMAT_12H = 'dd.MM.yyyy hh:mm A';
export const DATE_TIME_FORMAT_12H = 'dd.MM.yyyy hh:mm a';
export const DATE_TIME_FORMAT_24H = 'dd.MM.yyyy HH:mm';

export const DATE_PIPE_WITH_COMMA = 'dd.MM.yyyy, HH:mm';
export const DATE_PIPE_WITH_COMMA_12H = 'dd.MM.yyyy, hh:mm a';
